import {collection, field, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../sellable/controls/sellable-report-selection-control.component";


export class ProductCostingBomReportData extends LocalisableEntityData<ProductCostingBomReportData> {
    @field exclusive: boolean = true;
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @field priceLevel: number;

}
